//import PhoneNumber from 'awesome-phonenumber'

import Vue from 'vue'
import GMap from './gmap'
import StreetAddress from './street_address'
import { ValidationObserver, ValidationProvider, extend, localize } from 'vee-validate'
import VueSelect from 'vue-select'

import es from 'vee-validate/dist/locale/es.json'
import * as rules from 'vee-validate/dist/rules'

Object.keys(rules).forEach(rule => {
    extend(rule, rules[rule])
})

extend('decimal', {
    validate: (value, { decimals = '*', separator = '.' } = {}) => {
        if (value === null || value === undefined || value === '') {
            return {
                valid: false
            };
        }
        if (Number(decimals) === 0) {
            return {
                valid: /^-?\d*$/.test(value),
            };
        }
        const regexPart = decimals === '*' ? '+' : `{1,${decimals}}`;
        const regex = new RegExp(`^[-+]?\\d*(\\${separator}\\d${regexPart})?([eE]{1}[-]?\\d+)?$`);

        return {
            valid: regex.test(value),
        };
    },
    message: 'El campo {_field_} debe ser un valor decimal válido usando punto(.) como separador'
})

// extend('phone', {
//     message (fieldName) {
//         return `${fieldName} is not a valid phone number`;
//     },
//     validate (value) {
//         return new Promise(resolve => {
//             let phone = new PhoneNumber(value, 'CO');
//             resolve({ valid: phone.isValid() })
//         });
//     }
// });

localize("es", es)

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
Vue.component('GMap', GMap)
Vue.component('StreetAddress', StreetAddress)
Vue.component('VueSelect', VueSelect)